import { Database } from '../database'
import { Batch } from '../types'
import { CronInterface } from './cron.types'
import { Interval } from './interval'

const NONE_ITEMS = 0

export class Cron implements CronInterface{
  #database: Database
  #interval: Interval | undefined
  #callback: (items: Batch[])=> void

  constructor(
    batchTime: number, 
    callback: (items: Batch[]) => void,
    database: Database) {
    this.stop()
    this.#callback = callback
    this.#database = database
    this.#interval = new Interval(this.sendBatch.bind(this), batchTime)
  }

  async sendBatch() {
    const items  = await this.#database.getAllItems()

    if (items.length > NONE_ITEMS) {
      this.#callback(items)
    }
  }

  stop() {
    if (this.#interval) {
      this.#interval.stop()
      this.#interval = undefined
    }
  }
}
